
import { create } from "zustand";
import { devtools } from "zustand/middleware";





const storeApi = (set) => ({

    totalNotas: 0,
    activarNota: null,


    setActivarNotas: (valor) => {
        set({ activarNota: valor })
    },

});





export const useNotasStore = create(
    devtools(
        storeApi
    )
)
